webpackJsonp([13],{

/***/ 103:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    value: {
      type: String,
      default: '按钮'
    },
    belongs: {
      typy: String,
      default: 'btn'
    },
    btnW: {
      type: [String, Number]
    },
    disable: {
      type: Boolean,
      default: false
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    callback: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    }
  },
  data: function data() {
    return {
      btnActive: this.active,
      btnDisable: this.disable
    };
  },

  watch: {
    active: function active() {
      this.btnActive = this.active;
    },
    disable: function disable() {
      this.btnDisable = this.disable;
    }
  },
  methods: {
    btnClick: function btnClick() {
      if (this.disable) {
        return;
      }
      var that = this;
      function hideLoad() {
        if (that.loading) {
          that.btnActive = false;
        }
        that.btnDisable = false;
      }
      this.btnDisable = true;
      if (this.loading) {
        this.btnActive = true;
      }
      this.callback(hideLoad);
    }
  }
};

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Buttons = __webpack_require__(29);

var _Buttons2 = _interopRequireDefault(_Buttons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Btn: _Buttons2.default
  },
  data: function data() {
    return {
      active: true
    };
  },

  methods: {
    callback: function callback(cb) {
      setTimeout(function () {
        console.log(111, '回调结束');
        cb && cb();
        this.disable = false;
      }.bind(this), 3000);
      console.log('callback', this.active);
    }
  }
};

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _Buttons = __webpack_require__(42);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _router = __webpack_require__(5);

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

new _vue2.default({
  el: '#buttons',
  router: _router2.default,
  template: '<Buttons/>',
  components: { Buttons: _Buttons2.default }
});

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(13);


/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(4)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(3),
  /* scopeId */
  "data-v-12f6e127",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(103)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(74),
  /* scopeId */
  "data-v-905e65d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(99)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(70),
  /* scopeId */
  "data-v-68b91650",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(7);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Index = __webpack_require__(2);

var _Index2 = _interopRequireDefault(_Index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  routes: [{
    path: '/',
    name: 'Index',
    component: _Index2.default
  }]
});

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("标准")]), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "100%",
      "value": "btn 100%",
      "belongs": "btn",
      "callback": _vm.callback()
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "value": "btn-primary 30%",
      "belongs": "btn-primary",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "loading": "true",
      "value": "btn-primary",
      "belongs": "btn-primary radius",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "value": "btn-primary 30%",
      "belongs": "btn-primary",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "value": "btn-warn",
      "belongs": "btn-warn",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "loading": "true",
      "value": "btn-warn",
      "belongs": "btn-warn radius",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "value": "btn-warn",
      "belongs": "btn-warn radius20",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "value": "btn-delete",
      "belongs": "btn-delete",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "loading": "true",
      "value": "btn-delete",
      "belongs": "btn-delete radius",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "value": "btn-delete",
      "belongs": "btn-delete radius20",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "value": "btn-ghost 30%",
      "belongs": "btn-ghost",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "value": "btn-ghost 30%",
      "belongs": "btn-ghost radius",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "value": "btn-ghost 30%",
      "belongs": "btn-ghost radius20",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "20%",
      "value": "btn-more 200px",
      "disable": false,
      "belongs": "btn-more",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "20%",
      "value": "btn-disable",
      "loading": "true",
      "active": _vm.active,
      "disable": true,
      "belongs": "btn-disable",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "20%",
      "value": "btn-loading",
      "loading": "true",
      "belongs": "btn-loading",
      "callback": _vm.callback
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 74:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: _vm.belongs,
    style: ({
      width: _vm.btnW && (_vm.btnW + '').indexOf('%') > 0 ? _vm.btnW : _vm.btnW + 'px'
    }),
    attrs: {
      "disabled": _vm.btnDisable
    },
    on: {
      "click": function($event) {
        _vm.btnClick()
      }
    }
  }, [(_vm.loading && _vm.btnActive) ? _c('i', {
    staticClass: "icon-btn-loading",
    class: {
      active: _vm.btnActive
    }
  }) : _vm._e(), _vm._v(_vm._s(_vm.value) + "\n")])
},staticRenderFns: []}

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[139]);


// WEBPACK FOOTER //
// static/js/buttons.7c590465a3b9888173fd.js